/**
 * Mappers para convertir entre DTOs y modelos de dominio de Multimedia
 */

import { MultimediaItemDto } from '@infra/dto/multimedia.dto';
import { MultimediaItem } from '@domain/models/multimedia.model';

export class MultimediaMapper {
  /**
   * Convierte un DTO MultimediaItemDto a modelo de dominio
   */
  static toDomain(dto: MultimediaItemDto): MultimediaItem {
    return {
      id: dto.multimediaId,
      url: dto.url,
      description: dto.description,
      contentTypeId: dto.contentTypeId,
      showInPublicHome: dto.showInPublicHome,
      showInPrivateHome: dto.showInPrivateHome,
      createdAt: new Date(dto.createdAt)
    };
  }

  /**
   * Convierte una lista de DTOs a modelos de dominio
   */
  static toDomainList(dtos: MultimediaItemDto[]): MultimediaItem[] {
    return dtos.map(dto => MultimediaMapper.toDomain(dto));
  }

  /**
   * Convierte un modelo de dominio MultimediaItem a DTO
   */
  static toDto(item: MultimediaItem): MultimediaItemDto {
    return {
      multimediaId: item.id,
      url: item.url,
      description: item.description,
      contentTypeId: item.contentTypeId,
      showInPublicHome: item.showInPublicHome,
      showInPrivateHome: item.showInPrivateHome,
      createdAt: item.createdAt.toISOString()
    };
  }
}

